import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { money } from "@/components/status";
import { PiggyBank, TrendingUp, Users, Wallet } from "lucide-react";

export default function AdminRevenue() {
  const [data, setData] = useState({ ledger: [], totals: {} });
  useEffect(() => { api.get("/admin/revenue").then((r) => setData(r.data)); }, []);
  const t = data.totals || {};

  return (
    <div className="space-y-6" data-testid="admin-revenue">
      <div>
        <h1 className="font-heading font-black text-3xl tracking-tight text-sapphire">Platform Revenue</h1>
        <p className="text-muted-foreground text-sm mt-1">Your commission from every completed job (8% host + 8% cleaner).</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="border border-border rounded-md bg-sapphire text-white p-5" data-testid="rev-platform">
          <div className="flex items-center justify-between"><span className="text-xs uppercase tracking-[0.2em] text-white/60">Platform Revenue</span><PiggyBank className="w-4 h-4" /></div>
          <div className="font-heading font-black text-3xl mt-2">{money(t.platform_revenue)}</div>
        </div>
        <div className="border border-border rounded-md bg-white p-5">
          <div className="flex items-center justify-between"><span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Gross Volume</span><TrendingUp className="w-4 h-4 text-ocean" /></div>
          <div className="font-heading font-black text-3xl text-sapphire mt-2">{money(t.gross_volume)}</div>
        </div>
        <div className="border border-border rounded-md bg-white p-5">
          <div className="flex items-center justify-between"><span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Host Fees</span><Users className="w-4 h-4 text-ocean" /></div>
          <div className="font-heading font-black text-3xl text-sapphire mt-2">{money(t.host_fees)}</div>
        </div>
        <div className="border border-border rounded-md bg-white p-5">
          <div className="flex items-center justify-between"><span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Cleaner Fees</span><Wallet className="w-4 h-4 text-ocean" /></div>
          <div className="font-heading font-black text-3xl text-sapphire mt-2">{money(t.cleaner_fees)}</div>
        </div>
      </div>

      <div>
        <h2 className="font-heading font-bold text-xl text-sapphire mb-3">Commission Ledger</h2>
        <div className="border border-border rounded-md bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-border">
              <tr className="text-left text-xs uppercase tracking-wide text-muted-foreground">
                <th className="px-4 py-3">Host → Cleaner</th>
                <th className="px-4 py-3">Job Value</th>
                <th className="px-4 py-3">Host Charged</th>
                <th className="px-4 py-3">Cleaner Net</th>
                <th className="px-4 py-3">Platform Cut</th>
                <th className="px-4 py-3">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {data.ledger.map((p) => (
                <tr key={p.id} data-testid={`ledger-${p.id}`}>
                  <td className="px-4 py-3"><div className="font-semibold text-sapphire">{p.pm_name} → {p.cleaner_name}</div></td>
                  <td className="px-4 py-3">{money(p.base_amount ?? p.amount)}</td>
                  <td className="px-4 py-3">{money(p.gross_charge ?? p.amount)}</td>
                  <td className="px-4 py-3 text-emerald-700">{money(p.net_to_cleaner ?? p.amount)}</td>
                  <td className="px-4 py-3 font-semibold text-ocean">{money(p.platform_fee)}</td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(p.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
              {data.ledger.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">No revenue yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
